import SettingsInfo from "@/views/admin/settings/Info";

export default {
  path: "settings/info",
  name: "settings-info",
  component: SettingsInfo,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
